import React, { useState } from "react";
import { api, formatApiErrorDetail } from "../../lib/api";
import { KeyRound } from "lucide-react";
import { toast } from "sonner";

export const SettingsPanel = () => {
  const [form, setForm] = useState({ current_password: "", new_password: "", confirm: "" });
  const [saving, setSaving] = useState(false);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.new_password.length < 8) {
      toast.error("New password must be at least 8 characters");
      return;
    }
    if (form.new_password !== form.confirm) {
      toast.error("New passwords do not match");
      return;
    }
    setSaving(true);
    try {
      await api.post("/auth/change-password", {
        current_password: form.current_password,
        new_password: form.new_password,
      });
      toast.success("Password updated successfully!");
      setForm({ current_password: "", new_password: "", confirm: "" });
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Failed to update password");
    } finally {
      setSaving(false);
    }
  };

  const inputCls =
    "w-full rounded-lg border border-[#2a2a2a] bg-void px-4 py-3 text-sm text-ink outline-none transition-colors focus:border-gold";

  return (
    <div data-testid="settings-panel">
      <div className="mb-8">
        <h2 className="font-display text-3xl text-ink">Settings</h2>
        <p className="text-sm text-smoke mt-1">Manage your admin account.</p>
      </div>

      <form
        onSubmit={handleSubmit}
        className="max-w-md rounded-xl border border-line bg-surface p-8"
        data-testid="change-password-form"
      >
        <div className="mb-6 flex items-center gap-3">
          <span className="flex h-10 w-10 items-center justify-center rounded-full bg-gold/10 text-gold">
            <KeyRound size={18} />
          </span>
          <h3 className="font-display text-xl text-ink">Change Password</h3>
        </div>

        <div className="space-y-5">
          <div>
            <label className="mb-2 block text-xs uppercase tracking-widest text-smoke">Current Password</label>
            <input
              type="password"
              name="current_password"
              value={form.current_password}
              onChange={handleChange}
              required
              data-testid="current-password-input"
              className={inputCls}
            />
          </div>
          <div>
            <label className="mb-2 block text-xs uppercase tracking-widest text-smoke">New Password</label>
            <input
              type="password"
              name="new_password"
              value={form.new_password}
              onChange={handleChange}
              required
              data-testid="new-password-input"
              className={inputCls}
            />
          </div>
          <div>
            <label className="mb-2 block text-xs uppercase tracking-widest text-smoke">Confirm New Password</label>
            <input
              type="password"
              name="confirm"
              value={form.confirm}
              onChange={handleChange}
              required
              data-testid="confirm-password-input"
              className={inputCls}
            />
          </div>
          <button
            type="submit"
            disabled={saving}
            data-testid="change-password-btn"
            className="w-full rounded-full bg-gold px-8 py-3.5 text-sm font-semibold uppercase tracking-widest text-black transition-all duration-300 hover:-translate-y-0.5 disabled:opacity-60"
          >
            {saving ? "Updating..." : "Update Password"}
          </button>
        </div>
      </form>
    </div>
  );
};
